import { apolloClient } from '../apolloClient'
import { CONFIRM_KEYS_DELIVERY_INVITATION } from './mutations/CONFIRM_KEYS_DELIVERY_INVITATION'
import { ConfirmKeysDeliveryInvitationInput } from '../GlobalTypes'
import { confirmKDEI, confirmKDEIVariables } from '../types/confirmKDEI'
import { showErrorSnackbar } from '../../components/snackbar/Snackbar'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { setGlobal } from 'reactn'

export const confirmKeysDeliveryInvitation = async (input: ConfirmKeysDeliveryInvitationInput) => {
  try {
    await apolloClient.mutate<confirmKDEI, confirmKDEIVariables>({
      mutation: CONFIRM_KEYS_DELIVERY_INVITATION,
      variables: { input },
    })

    await setGlobal({
      shouldRefreshKeysDelivery: true,
    })
  } catch (err) {
    console.log('Could not confirm presence on keys delivery event. Reason: ', err)
    showErrorSnackbar(formatMessage(messages.appointments_couldNotRespondToEvent))
  }
}
